<!--BEGIN CONTENT-->

<app-notify-message></app-notify-message>

<div class="marketplace-page">
  <aside class="marketplace-page__sidebar sidebar-shadow">
    <app-side-menu [sideData]="message"></app-side-menu>
  </aside>

  <main class="marketplace-page__content">
    <section id="main_content" class="bg marketplace-page__main">
      <header class="marketplace-page__header">
        <div>
          <h1 class="marketplace-page__title">Marketplace</h1>
          <p class="marketplace-page__subtitle">
            Integrations available for your account
          </p>
        </div>
      </header>

      <div class="marketplace-page__list">
        @for (item of items; track item.id) {
          <article class="marketplace-card">
            <div class="marketplace-card__logo">
              <img [src]="item.image" [alt]="item.name" />
            </div>
            <div class="marketplace-card__body">
              <h2 class="marketplace-card__name">{{ item.name }}</h2>
              <p class="marketplace-card__desc">{{ item.description }}</p>
            </div>
            <div class="marketplace-card__status">
              @if (item.enabled) {
                <span class="marketplace-card__badge marketplace-card__badge--enabled">
                  <i class="fa-solid fa-check" aria-hidden="true"></i>
                  Enabled
                </span>
              } @else {
                <span class="marketplace-card__badge marketplace-card__badge--disabled">
                  Disabled
                </span>
              }
            </div>
          </article>
        }
      </div>
    </section>
  </main>
</div>
